import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var ConfirmationPopUp = function (_ref) {
    var onClose = _ref.onClose, unsavedChangesMessage = _ref.unsavedChangesMessage, changesLostMessage = _ref.changesLostMessage, confirmButtonLabel = _ref.confirmButtonLabel, discardButtonLabel = _ref.discardButtonLabel, icon = _ref.icon, bgColor = _ref.bgColor, hoverbgColor = _ref.hoverbgColor;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            display: 'flex',
            flexDirection: 'row',
            columnSize: 12,
            spacing: 0,
            gap: '16px',
            padding: '20px 16px 0px 16px',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: icon,
                            columnSize: 0,
                            sx: {
                                bgcolor: bgColor,
                                cursor: 'pointer',
                                padding: '12px',
                                ':hover': {
                                    bgcolor: hoverbgColor
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            },
                            sx: {
                                padding: '12px'
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: unsavedChangesMessage,
                            fontWeight: 'strong',
                            fontSize: 'xl',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            value: changesLostMessage,
                            columnSize: 12,
                            fontWeight: 'normal',
                            color: '#8593A3'
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            display: 'flex',
            justifyContent: 'end',
            columnSize: 12,
            spacing: 0,
            gap: '16px',
            padding: '32px 24px 24px 24px',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: discardButtonLabel,
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: confirmButtonLabel,
                    columnSize: 0,
                    onClick: function () {
                        onClose(true);
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0
    });
};
export default ConfirmationPopUp;
